module.exports = __webpack_public_path__ + "static/img/telephone_num.9d5df8f8.png";